// shared
import runScripts from 'views/assets/scripts/runScripts'

// page specific
import slider from 'views/assets/scripts/slider'
import registerStretchSlider from 'views/assets/scripts/registerStretchSlider'
import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import video from 'views/assets/scripts/video'
import videoBox from 'views/assets/scripts/videoBox'
import mountLastActivityContainer from 'views/containers/browser/LastActivityContainer/mountLastActivityContainer'
import mountAlgoliaSearchComponent from 'views/containers/browser/AlgoliaInstantSearchContainer/mountAlgoliaSearchComponent'
import mountMoreProductsContainer from 'views/containers/browser/MoreProductsContainer/mountMoreProductsContainer'
import dismiss from 'views/assets/scripts/dismiss'
import medicationPlan from 'views/assets/scripts/medicationPlan'
import homeCswAsSlider from 'shared/experiments/browser/homeCswAsSlider/homeCswAsSlider'
import swapCswAndServices from 'shared/experiments/browser/swapCswAndServices/swapCswAndServices'
import mountSubscriptionClientContainer from 'views/containers/browser/SubscriptionClientContainer/mountSubscriptionClientContainer'

runScripts(
  slider,
  registerStretchSlider,
  chargeUrlSearchParams,
  video,
  videoBox,
  mountLastActivityContainer,
  mountAlgoliaSearchComponent,
  mountMoreProductsContainer,
  dismiss,
  medicationPlan,
  swapCswAndServices,
  homeCswAsSlider,
  mountSubscriptionClientContainer
)
